import API from "./API";

export default class DiaryRejections extends API {
    static async create(data) {
        return this.post("api/admin/diary-rejections", data);
    }

    static async getByDiary(diaryId) {
        return this.get(`api/admin/diary-rejections/diary/${diaryId}`);
    }
}